exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.display-grid[data-v-0b0345f3] {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 47% 51%;\n      grid-template-columns: 47% 51%;\n  -ms-grid-rows: 1fr;\n      grid-template-rows: 1fr;\n  grid-template-areas: \". .\";\n}\n.prices-grid[data-v-0b0345f3] {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 80% 20%;\n      grid-template-columns: 80% 20%;\n  -ms-grid-rows: 1fr;\n      grid-template-rows: 1fr;\n  gap: 0px 0%;\n  grid-template-areas: \". .\";\n}\n.elipsis[data-v-0b0345f3] {\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.detailLabel[data-v-0b0345f3] {\n  width: 80px;\n}\n.infinity-height[data-v-0b0345f3] {\n  height: 17px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0b0345f3","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/EventDetails.vue
// module id = 2700
// module chunks = 0